import { render } from "./Header.vue?vue&type=template&id=cf198fd8&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=cf198fd8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cf198fd8"

export default script